export type { QuizExitConfirmationProps } from "./QuizExitConfirmation";
export { QuizExitConfirmation } from "./QuizExitConfirmation";
